/* eslint-disable no-console */

import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import FormLink from './views/FormLink.vue'
import FormTextLink from './views/FormTextLink.vue'
import FormCategory from './views/FormCategory.vue'
import FormTask from './views/FormTask.vue'
import FormAnuncie from './views/FormAnuncie.vue'
import FormRegistrar from './views/FormRegistrar.vue'
import Contato from './views/Contato.vue'
import QuemSomos from './views/QuemSomos.vue'
import Politica from './views/Politica.vue'
import Termos from './views/Termos.vue'
import Setup from './views/Setup.vue'
import SiteInicio from './views/SiteInicio.vue'
import Loader from './components/Loader.vue'
import Mobile from './views/Mobile.vue'
import Tutorial from './views/Tutorial.vue'
import Admin from './views/Admin.vue'
import Migracao from './views/Migracao.vue'
import AddSharedCategory from './views/AddSharedCategory.vue'
import AddSharedDashboard from './views/AddSharedDashboard.vue'
import ModalGif from './views/ModalGif.vue'
import MeuPerfil from './views/MeuPerfil.vue'

//import SignUp from './views/SignUp.vue'
//import About from './views/About.vue'
//import ProjectList from './views/ProjectList.vue'
//import ProjectForm from './views/ProjectForm.vue'
//import ProjectView from './views/ProjectView.vue'
//import TaskForm from './views/TaskForm.vue'
//import TaskView from './views/TaskView.vue'

import store from './store'

Vue.use(Router)

const router = new Router({
  mode:'history',
  routes: [
  {
    path: '/',
    name: 'loader',
    component: Loader,
    meta: {restricted:false},
  },
  {
    path: '/painel',
    name: 'home',
    component: Home,
    meta: {restricted:true},
  },
  {
    path: '/tutorial',
    name: 'tutorial',
    component: Tutorial,
    meta: {restricted:false},
    
  },
  {
    path: '/exemplo',
    name: 'exemplo',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:ModalGif,
    }
  },
  {
    path: '/setup',
    name: 'setup',
    component: Setup,
    meta: {restricted:true},
  },
  {
    path: '/mobile',
    name: 'mobile',
    meta: {restricted:false},
    component:Mobile,
  },
  {
    path: '/textlinks',
    name: 'formTextlink',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:FormTextLink,
    }
  },
  {
    path: '/link-new',
    name: 'formLinkNew',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:FormLink,
    }
  },
  {
    path: '/link-edit',
    name: 'formLink',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:FormLink,
    }
  },
  {
    path: '/suggestion',
    name: 'formLinkSuggestion',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:FormLink,
    }
  },
  {
    path: '/new-category',
    name: 'formNewCategory',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:FormCategory,
    }
  },
  {
    path: '/form-task',
    name: 'formTask',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:FormTask,
    }
  },
  {
    path: '/anuncie',
    name: 'formAnuncie',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:FormAnuncie,
    }
  },
  {
    path: '/registrar',
    name: 'formRegistrar',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:FormRegistrar,
    }
  },
  {
    path: '/task/:task',
    name: 'formTaskEdit',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:FormTask,
    }
  },
  {
    path: '/site-inicio',
    name: 'site-inicio',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:SiteInicio,
    }
  },
  {
    path: '/login',
    name: 'login',
    meta: {restricted:false},
    component: Login,
  },
  {
    path: '/politica-de-privacidade',
    name: 'politica-de-privacidade',
    meta: {restricted:false},
    component:Politica,
  },
  {
    path: '/termos-e-condicoes',
    name: 'termos-e-condicoes',
    meta: {restricted:false},
    component:Termos,
  },
  {
    path: '/contato',
    name: 'contato',
    meta: {restricted:false},
    component: Contato,
  },
  {
    path: '/quem-somos',
    name: 'quem-somos',
    meta: {restricted:false},
    component: QuemSomos,
  },
  {
    path: '/admin',
    name: 'admin',
    meta: {restricted:true},
    component: Admin,
  },
  {
    path: '/migracao',
    name: 'migracao',
    meta: {restricted:true},
    component: Migracao,
  },
  {
    path: '/category-edit',
    name: 'formCategory',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:FormCategory,
    }
  },
  {
    path: '/add-shared-category',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:AddSharedCategory,
    }
  },
  {
    path: '/add-shared-dashboard',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:AddSharedDashboard,
    }
  },
  {
    path: '/meu-perfil',
    name: 'meu-perfil',
    meta: {restricted:true},
    props: {default:true, popup: true},
    components: {
      default:Home,
      popup:MeuPerfil,
    }
  },

  ]
})


router.beforeEach((to, from, next) => {

/*
  if(to.path != '/mobile' && window.isMobile()){
    return next({ name: 'mobile' })
  }
*/

  console.log('route beforeeach to: ',to.path);

  window.scrollTo(0,0);

  if(store.state.authInitialized) {

    if(!store.state.isAuthenticated && to.meta.restricted){
      return next({ name: 'login' })
    }

    if(store.state.isAuthenticated && (to.path == '/login' || to.path == '/demo' || to.path == '/')){
      return next({ name: 'home' })
    }
  }

  store.dispatch('setIntendedUrl',{url:to.path});

  var match;
  if(match = to.path.match(/shared\/([a-z]\d+)/)){
    console.log('matched',match);
    store.dispatch('setSharedCategoryId',{id:match.pop()});
    store.dispatch('setIntendedUrl',{url:''});
  }
  if(match = to.path.match(/ref\/([a-z]\d+)/)){
    console.log('matched',match);
    store.dispatch('setSharedDashboardId',{id:match.pop()});
    store.dispatch('setIntendedUrl',{url:''});
  }

  next();

});

export default router